


import {
    IonContent, IonGrid, IonRow, IonCol, IonInput, IonButton, IonAlert,modalController
} from '@ionic/vue';
import { defineComponent  } from 'vue';
import { LoginUtility } from '../LoginUtility/LoginUtility';

import { useRouter } from 'vue-router';
import { useApplicationStore } from '@/stores/ApplicationStore';

//import { useStore } from 'vuex'
// import { key } from '../../store'

export default defineComponent({
    name: "LoginPage",
    components: {
        IonContent, IonGrid, IonRow, IonCol, IonInput, IonButton, IonAlert
    },
    setup(){
        const router = useRouter();
        return { router};
    },
    data() {
        return {

            model: {
                username: '',
                password: '',

            },
            AlertMessage: "",
            isOpenRef: false,

        }
    },
    methods: {
        Login_click() {
            console.log(this.model.username);
            if (!this.model.username) {
                //metti un utente
                this.ShowAlert(true, "Inserire un utente");

                return;
            }

            if (!this.model.password) {
                //metti una pass
                this.ShowAlert(true, "Inserire una password");

                return;
            }

            //eseguo login
            const loginUtility = new LoginUtility();
            const store = useApplicationStore();
            loginUtility.LogIn(this.model.username, this.model.password, this.$API_AUTH_URL, this.$API_DBOX_URL, this.$API_KEY).finally(() => {
                if (store.$APP_READY) {
                    this.router.push('/etichetteApp/tab2');
                    //chiudo il modale
                    
                    modalController.dismiss();
                }else{
                    //mando messaggio errore server
                    this.ShowAlert(true, "Errore di login controllare username e password");
                }

                // Expected output: 123
            });//.catch(error =>  console.log(error));
        },
        ShowAlert(state: boolean, message: string) {
            this.AlertMessage = message;
            this.isOpenRef = state;
        },

    }
})

